import React from "react"
import CookieConsent from "react-cookie-consent"

const CookieBar = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="OK"
      cookieName="ukl_terms_and_conditions_understood"
      style={{ background: "#000000", textAlign: "center", fontSize: "12px" }}
      buttonStyle={{ backgroundColor: "#fe9900", color: "#ffff" }}
    >
      <span>
        We use cookies in line with our <a className="terms_and_conditions_link" href="https://uklifeinsurance.co.uk/privacy.php"> Privacy Policy</a>, this may include for purposes of personalised advertising. Continued
        use of this site indicates you are happy with this.
      </span>
    </CookieConsent>
  )
}

export default CookieBar